import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { getDlsCompatibleList } from "./selector";
import { Label } from "@cars24/turbo-web/lib/label";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { Table } from "@cars24/turbo-web/lib/table";
import { NUMBER } from "../../../constants/app-constants";
import { PAGE_TYPES } from "../../../constants/rto-constants";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import styles from "./styles.css";

const LIST_THRESHOLD_LIMIT = 5;

const heading = [
    {
        "label": "RTO office",
        "key": "name",
        "hyperLinkKey": "name"
    },
    {
        "label": "RTO code",
        "key": "code",
        "hyperLinkKey": ""
    }
];

const RtoVehInfoRtoList = ({
    rtoList,
    pageType,
    state,
    isDesktop = false,
    isWebview = false
}) => {
    const { tokens } = useTokens();
    const title = pageType === PAGE_TYPES.STATE ? `Details of ${state} RTO Offices` : `List of other RTO offices in ${state}`;
    const itemList = useMemo(() => getDlsCompatibleList(rtoList), [rtoList]);
    // };

    if (pageType === PAGE_TYPES.HOME) return null;
    return (
        <div styleName={`styles.rtoVehInfoRtoList ${isWebview ? "styles.rtoListPb" : ""}`} className={"cvh"}>
            {
                isDesktop ? <Heading level={NUMBER.TWO}>{title}</Heading> :
                    <Label level={NUMBER.ONE} fontWeight={"semibold"}>{title}</Label>
            }
            <Table
                isExpandable={rtoList && rtoList.length > 0 &&  rtoList.length > LIST_THRESHOLD_LIMIT}
                isStriped={true}
                heading={heading}
                data={itemList}
                visibleRowCount={LIST_THRESHOLD_LIMIT}
                expandedText={"View less RTOs"}
                collapsedText={"View more RTOs"}
                color={tokens.text_default_text_primary}
                stripColor={tokens.background_surface_default_surface_secondary}
                expandVariant="brand"
            />
        </div>
    );
};

RtoVehInfoRtoList.propTypes = {
    rtoList: PropTypes.array,
    pageType: PropTypes.string,
    state: PropTypes.string,
    isDesktop: PropTypes.bool,
    isWebview: PropTypes.bool
};

export default RtoVehInfoRtoList;
